if (!window.palbon_webshop) window.palbon_webshop = {};
if (!frappe.boot) frappe.boot = {};
